
import { useEffect } from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import ContactHero from './components/ContactHero';
import ContactInfo from './components/ContactInfo';
import ContactForm from './components/ContactForm';
import LocationMap from './components/LocationMap';

const ContactPage = () => {
  useEffect(() => {
    // Update page title and meta description for contact page
    document.title = 'Contact OED Glamping Talladega Alabama - Investment & Booking Inquiries';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Contact OED Glamping in Talladega, Alabama for investment opportunities and booking inquiries. Call 256-268-7146 or visit our office. Get started with your glamping investment today.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'contact OED Glamping, Talladega Alabama office, glamping investment inquiries, booking information, 256-268-7146');
    }

    // Update social media images
    const ogImage = document.querySelector('meta[property="og:image"]');
    if (ogImage) {
      ogImage.setAttribute('content', 'https://public.readdy.ai/ai/img_res/72ad96fca68c40911daa4c96b0e302d5.jpg');
    }

    const twitterImage = document.querySelector('meta[property="twitter:image"]');
    if (twitterImage) {
      twitterImage.setAttribute('content', 'https://readdy.ai/api/search-image?query=Professional%20OED%20Glamping%20office%20building%20in%20Talladega%20Alabama%20with%20modern%20eco-friendly%20architecture%2C%20contact%20information%20display%2C%20business%20headquarters%20with%20natural%20landscaping%2C%20professional%20corporate%20photography%20with%20welcoming%20atmosphere&width=1200&height=630&seq=contact-twitter&orientation=landscape');
    }

    // Add ContactPage Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "ContactPage",
      "name": "Contact OED Glamping",
      "description": "Contact OED Glamping in Talladega, Alabama for investment opportunities and booking inquiries. Professional glamping consultation services available.",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/contact`,
      "mainEntity": {
        "@type": "Organization",
        "name": "OED Glamping",
        "telephone": "+1-256-268-7146",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "123 Glamping Way",
          "addressLocality": "Talladega",
          "addressRegion": "AL",
          "postalCode": "35160",
          "addressCountry": "US"
        }
      }
    });
    document.head.appendChild(script);

    return () => {
      const existingScript = document.querySelector('script[type="application/ld+json"]');
      if (existingScript && existingScript.textContent?.includes('ContactPage')) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <main>
        <header>
          <h1 className="sr-only">Contact OED Glamping Talladega Alabama</h1>
          <ContactHero />
        </header>
        <section aria-label="Contact Information">
          <ContactInfo />
        </section>
        <section aria-label="Contact Form">
          <ContactForm />
        </section>
        <section aria-label="Location Map">
          <LocationMap />
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default ContactPage;
